// extracted by mini-css-extract-plugin
export var collapsedSummary = "_q3-0";